import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgLockOpen = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M8 0a4 4 0 0 1 3.906 3.138 1 1 0 1 1-1.953.43A2.001 2.001 0 0 0 6 4v2h6a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2V4a4 4 0 0 1 4-4"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLockOpen);
export default ForwardRef;
